module.exports = __webpack_public_path__ + "img/dashed.c7b5f8a3.svg";